export default "__VITE_ASSET__paPlIH2B__"